<template>
  <div class="upload-release">
    <h5 v-if="releaseContents?.name" class="app-step-two-tabs-upload__upload">
      Uploaded Document:
      <span class="hyphenate"
        >{{ releaseContents.name }} (Word Count: {{ wordCount }} words)</span
      >
    </h5>
    <div class="app-step-two-tabs-upload-row step-row">
      <div class="app-step-two-tabs-upload-row__col step-col">
        <p class="app-step-two-tabs-upload-row__title">Upload your release</p>
        <span class="app-step-two-tabs-upload-row__note">
          .rtf, .doc, .docx only</span
        >
      </div>
      <div class="app-step-two-tabs-upload-row__col step-col">
        <app-tooltip>
          <span class="app-step-two-tabs-upload-row__descr"
            >Do you need to change the file that you uploaded?</span
          >
          <template #tooltip>
            To make a change to your document, please re-name and save your
            document, then use the Choose File button to select the new file and
            the revised document will be used for your order.<br /><br />If you
            need to change the document AFTER you have submitted your order, you
            may email it to us at
            <a target="_blank" href="mailto:pr@ereleases.org"
              >pr@ereleases.org</a
            >, and our editors will make the needed change to your order
          </template>
        </app-tooltip>
        <app-file-selector
          refName="releaseContent"
          accept=".doc,.docx,application/msword,.rtf"
          :error="error"
          :disabled="isLoading"
          @update:file="handleFileUpdate"
        ></app-file-selector>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs, defineProps, defineEmits } from 'vue'
import { useUploadRelease } from './useUploadRelease'
import AppTooltip from '@modules/ui/app-tooltip.vue'
import AppFileSelector from '@modules/ui/app-file-selector.vue'

const props = defineProps(['modelValue', 'error', 'updateOrder'])
const emit = defineEmits(['update:modelValue'])

const { modelValue: releaseContents } = toRefs(props)

const { wordCount, isLoading } = useUploadRelease(
  releaseContents,
  props.updateOrder
)

const handleFileUpdate = (file) => emit('update:modelValue', file)
</script>
